let eventCategories = [
    'CategorySelection',
    'LocationSelection',
    'AddToCart',
    'RemoveFromCart',
    'JobAdOpened'
];

class AnalyticsService {

    constructor() {
        window.dataLayer = window.dataLayer || [];
    }

    pushEvent(category, action, meta = {}) {
        console.log(category, action);

        if(!eventCategories.includes(category)){
            console.error("Analytics Service: Event category does not exist.");
            return;
        }

        let event = {
            'event': 'gtmEvent',
            'eventCategory': category,
            'eventAction': action
        }

        // Add meta fields to event
        event = Object.assign(event, meta);

        window.dataLayer.push(event);
    }

}

export default new AnalyticsService();